@import 'styles/mixins';
@import 'styles/blaze/mixins';

.card {
  position: relative;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 0;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    border: 1px solid var(--dark-8);
    pointer-events: none;
    z-index: 1;
  }
}

.headerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  z-index: 2;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

.creditIcon {
  flex-shrink: 0;
}

.seeDetailsButton {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 4px 0;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }
}

.infoIcon {
  flex-shrink: 0;
}

.popoverBackdrop {
  z-index: 100000;
}

.creditBreakdownPopover {
  width: 222px;
  max-width: 316px;
  padding: 20px;
  overflow: auto;
}

/* Tooltip variant - same visual style as popover */
.creditBreakdownTooltip {
  @include dropdown-shadow;
  @include hide-scrollbar;
  @include blur;
  width: 222px;
  max-width: 316px;
  padding: 20px;
  overflow: auto;
  background: var(--light-80);
  color: var(--dark-90);
  text-align: left;
  border-radius: 6px;
  border: 1px solid var(--dark-4);
  box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.05);

  [data-autopilot-system-redesign='on'] & {
    background: var(--light-100);
  }
}

.creditBreakdownTooltipContent {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.popoverHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.popoverCloseButton {
  margin: -4px;
}

.popoverContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.creditBreakdownSection {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.creditBreakdownSectionHeader {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.creditBreakdownRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  > *:first-child {
    text-align: left;
    flex: 1;
  }

  > *:last-child {
    text-align: right;
    flex-shrink: 0;
  }
}

.creditBreakdownRowIndent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding-left: 12px;

  > *:first-child {
    text-align: left;
    flex: 1;
  }

  > *:last-child {
    text-align: right;
    flex-shrink: 0;
  }
}

.sectionTitle {
  margin-bottom: 4px;
}

.creditBreakdownDivider {
  height: 1px;
  background: var(--dark-8);
  margin: 4px 0;
}

.seeDetailsLink {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;

  &:hover {
    opacity: 0.8;
  }
}

.divider {
  height: 1px;
  background: var(--dark-4);
  margin: 16px 0;
  width: 100%;
}

.detailsSection {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.expiringCredits {
  display: flex;
  align-items: center;
  gap: 4px;
}

.controlsRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: auto;
}

.autoReloadControl {
  display: flex;
  align-items: center;
  gap: 10px;
}

.autoReloadIcon {
  flex-shrink: 0;
}

.autoReloadLabel {
  margin: 0;
}

.autoReloadPill {
  @include sm-sohne;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.56px;
  line-height: 110%;

  &.on {
    background: var(--green-10);
    color: var(--green-50);
    border: 1px solid var(--dark-4);
  }

  &.off,
  &.off {
    background: var(--dark-3);
    border: 1px solid var(--dark-4);
    color: var(--dark-90);
  }

  &.paused {
    background: #ffc800;
    color: var(--dark-90);
    border: 1px solid var(--dark-4);
  }
}

.addCreditsButton {
  margin-left: auto;
}
